import { NavLink } from "react-router-dom";
import ArticlePage from "./ArticlePage";
import { links, pages, navLinks } from "../data/site";
import {
  breadcrumbSchema,
  buildGraph,
  webpageSchema,
} from "../data/schema";

const OpenSourcePage = () => {
  const seo = pages.openSource;
  const schema = buildGraph([
    webpageSchema(seo),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Open Source", path: seo.path },
    ]),
  ]);

  return (
    <ArticlePage
      seo={seo}
      schema={schema}
      theme="dark"
      bigTitle="OSS"
      heading="Open source — Hareesh Rajendran"
      related={navLinks.filter((link) => link.to !== seo.path)}
    >
      <p>
        Hareesh Rajendran publishes and contributes to open-source software from{" "}
        <a href={links.github} target="_blank" rel="noopener noreferrer me">
          github.com/hareesh-r
        </a>
        .
      </p>
      <ul>
        <li>1.8K GitHub followers</li>
        <li>69 repositories</li>
        <li>Pull Shark ×2</li>
        <li>Starstruck ×2</li>
        <li>YOLO</li>
      </ul>

      <h2>Tamilnadu.tech</h2>
      <p>
        Contributor,{" "}
        <a
          href={links.tamilnaduTech}
          target="_blank"
          rel="noopener noreferrer"
        >
          Tamilnadu.tech
        </a>
        , 2025.
      </p>

      <h2>DSA in Java</h2>
      <p>
        Open-source repository:{" "}
        <a
          href={links.githubDsaJava}
          target="_blank"
          rel="noopener noreferrer"
        >
          Data Structures and Algorithms in Java
        </a>
        . See more builds on the <NavLink to="/projects">projects</NavLink> page.
      </p>
    </ArticlePage>
  );
};

export default OpenSourcePage;
